import React from 'react';
import PropTypes from 'prop-types';
import { Liabilities as SectionKey } from 'Consts/Questionnaire';
import { NotificationManager } from 'react-notifications';
import CircleWithCount from 'Icons/CircleWithCount';
import Section from '../Section';
import NumberInput from '../Fields/NumberInput';
import FetchValue from '../Fields/FetchValue';

function creditLimitRule(val) {
  let v = val;
  if (v == null) return null;
  if (v > 850) {
    NotificationManager.error('Credit score must fall between 300 and 850.');
    v = null;
  } else if (v < 300) {
    NotificationManager.error('Credit score must fall between 300 and 850.');
    v = null;
  }

  return v;
}

const SignificantOtherCreditScore = ({ id, value: status }) => {
  if (status === 'married' || status === 'significantOther') {
    return (
      <NumberInput
        placeholder="What is your significant other's credit score?"
        name={`significantOtherCreditScore.${id}`}
        answerKey="significantOtherCreditScore"
        blurOverride={creditLimitRule}
        decimalScale={0}
      />
    );
  }

  return null;
};

SignificantOtherCreditScore.propTypes = {
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
};

const Libs = ({
  id,
}) => {
  return (
    <Section
      CountComponent={<CircleWithCount count={0} className="expander-header-count expander-header-left" />}
      transitionSpeed={0.25}
      height={400}
      title="Credit Score"
      expanded
      sectionKey={SectionKey}
    >
      <NumberInput
        placeholder="What is your credit score?"
        name={`clientCreditScore.${id}`}
        answerKey="clientCreditScore"
        blurOverride={creditLimitRule}
        decimalScale={0}
      />

      <FetchValue
        name={`clientMaritalStatus.${id}`}
        answerKey="clientMaritalStatus"
        OnMountRender={SignificantOtherCreditScore}
      />
    </Section>
  );
};

Libs.propTypes = {
  id: PropTypes.number.isRequired,
};

export default Libs;
